import { Warning } from '@/UI/Warning';
import { AvatarEdit } from './AvatarEdit';
import { FullName } from './FullName';
import { Email } from './Email';
import { DeleteButton } from './DeleteButton';
import i18n from '@/localisation/i18n';
import { useUserStore } from '@/store/user';
import { motion } from 'framer-motion';
import { HeaderInfo } from '@/UI/HeaderInfo';
import { Appear } from '@/UI/animations/Appear';
import { Language } from './Language';

export const Profile = () => {
  const { img, name } = useUserStore();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      className="w-full"
    >
      <HeaderInfo
        title={i18n.t('settings')}
        subtitle={i18n.t('settings.subtitle')}
        backUrl="/"
      >
        <div className="mt-6 block w-full rounded-lg bg-card px-5 py-3 md:hidden md:rounded-2xl">
          <h4 className="text-base">{i18n.t('profile')}</h4>
        </div>

        <div className="mt-3 flex h-[calc(100vh-260px)] flex-col items-start rounded-lg bg-card px-3 py-3 md:mt-8 md:h-[calc(100vh-180px)] md:rounded-2xl md:px-5">
          <div className="hidden w-full md:block">
            <h4 className="mb-3 text-lg font-semibold md:mb-5">
              {i18n.t('profile')}
            </h4>
            <div className="divider"></div>
          </div>

          <Appear className="w-full" isVisible={!img || !name}>
            <div className="mb-3 w-full md:mt-4">
              <Warning
                title={i18n.t('warning.profile.title')}
                subtitle={i18n.t('warning.profile.subtitle')}
              />
            </div>
          </Appear>
          <div className="w-full">
            <AvatarEdit />
          </div>
          <FullName />
          <Email />
          <Language />
          <DeleteButton />
        </div>
      </HeaderInfo>
    </motion.div>
  );
};
